<ng-container *ngIf="(chatLinksLength$ | async) > 1; else singleLink">
  <div>
    <button (click)="chatMenuComponentService.toggle()">
      <cx-icon [type]="iconType.CHAT_ROUND"></cx-icon>
    </button>
    <div>
      <cx-page-slot position="ChatMobileMenuSlot"></cx-page-slot>
    </div>
  </div>
</ng-container>

<ng-template #singleLink>
  <div class="single-link">
    <cx-page-slot position="ChatMobileMenuSlot"></cx-page-slot>
  </div>
</ng-template>
